import { themeProps } from '@/interface';

export const createStyles = (theme: themeProps) => ({
  '::-webkit-scrollbar': {
    width: '6px'
  },

  '::-webkit-scrollbar-thumb': {
    backgroundColor: '#D7D8DB',
    borderRadius: '6px'
  },

  '::-webkit-scrollbar-track': {
    backgroundColor: '#f1f1f1'
  },

  'html, body': {
    fontFamily: theme.fontFamily.tertiary,
    minHeight: '100vh',
    margin: 0,
    background: theme.color?.backgroundColor
  },

  body: {
    fontFamily: theme.fontFamily.tertiary,
    overflowY: 'scroll'
  },

  'audio::-webkit-media-controls-enclosure': {
    borderRadius: '10px',
    backgroundColor: '#8C939E'
  }
});
